<footer class="spen-ly-global-footer">
  <div class="spen-util-inner">
    <div class="footer-link-list">
      <div class="footer-link">
        <a href="{{ helpUrl }}" target="_blank" rel="noopener noreferrer" class="spen-util-link">ヘルプページ</a>
      </div>
      @if (isTeacher) {
        <div class="footer-link">
          <a href="{{ inquiryUrl }}" target="_blank" rel="noopener noreferrer" class="spen-util-link">お問い合わせ</a>
        </div>
      }
      @if (isParent) {
        <div class="footer-link">
          <a href="{{ parentsNoticeUrl }}" target="_blank" rel="noopener noreferrer" class="spen-util-link">利用に関する注意事項</a>
        </div>
      }
      @if (isParent) {
        <div class="footer-link">
          <a href="{{ studentsNoticeUrl }}" target="_blank" rel="noopener noreferrer" class="spen-util-link">利用に関する注意事項(生徒)</a>
        </div>
      }
      @if (isStudent) {
        <div class="footer-link">
          <a href="{{ studentsNoticeUrl }}" target="_blank" rel="noopener noreferrer" class="spen-util-link">利用に関する注意事項</a>
        </div>
      }
    </div>
    <p class="copy-right-text">© Benesse Corporation. All rights reserved</p>
  </div>
</footer>
